import { proposalDirectiveEntries } from '../../constants/proposalDirectiveEntries.constant'
import { ManualEntryProposalShowData } from '../../types/maintenanceManualEntryProposal.type'

type Props = {
  proposal: ManualEntryProposalShowData
  onAccepted?: () => void
}

const ProposalAddProposalButton = ({ proposal, onAccepted }: Props) => {
  const directiveEntryType = proposal.manual_entry?.forwarding?.directive_entry_type
  const AddProposalAction = directiveEntryType ? proposalDirectiveEntries[directiveEntryType]?.AddProposalAction : undefined

  if (!AddProposalAction) {
    return null
  }

  return <AddProposalAction proposal={proposal} onAccepted={onAccepted} />
}

export default ProposalAddProposalButton
